import React from 'react';

const NotificationMenu = () => (
  <li className="nav-item dropdown-notifications navbar-dropdown dropdown me-4 me-xl-1">
    <a
      className="nav-link btn btn-text-secondary rounded-pill btn-icon dropdown-toggle hide-arrow"
      href="javascript:void(0);"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      aria-expanded="false"
    >
      <i className="ri-notification-2-line ri-22px"></i>
      <span className="position-absolute top-0 start-50 translate-middle-y badge badge-dot bg-danger mt-2 border"></span>
    </a>
    <ul className="dropdown-menu dropdown-menu-end py-0">
      <li className="dropdown-menu-header border-bottom py-50">
        <div className="dropdown-header d-flex align-items-center py-2">
          <h6 className="mb-0 me-auto">Notification</h6>
          <span className="badge rounded-pill bg-label-primary fs-xsmall me-2">8 New</span>
        </div>
      </li>
      {/* Add notification items here */}
      <li className="border-top">
        <div className="d-grid p-4">
          <a className="btn btn-primary btn-sm d-flex" href="javascript:void(0);">
            <small className="align-middle">View all notifications</small>
          </a>
        </div>
      </li>
    </ul>
  </li>
);

export default NotificationMenu;
